import { IApplicationState } from '../../types/redux';

export function experimentsReducer(state: IApplicationState['experiments'] = []): IApplicationState['experiments'] {
  return state;
}
